import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { JobModel } from '../../../models/job-model';
import { JobParamenterModel } from 'app/models/job-parameter-model';
import * as moment from 'moment-timezone';
import { Log } from 'app/core/logging/log';

@Component({
  selector: 'app-admin-schedule',
  templateUrl: './admin-schedule.page.html',
  styleUrls: ['./admin-schedule.page.scss'],
})
export class AdminSchedulePage implements OnInit {
  
  jobs: JobModel[] = [];
  displayedColumns: string[] = ['jobName', 'scheduleTime', 'lastFiredTime', 'groupName', 'jobStatus', 'result', 'nextFireTime'];
  
  constructor(    
    private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.getJobs();
  }



  jobModalManager(job?: JobModel) {
    console.log('job', job);

    let isNew: boolean = true;
    let jobParamenter: JobParamenterModel =  {
      jobName: '',
      jobScheduleTime: '',
      cronExpression: ''
    };

    if(job != null){
      let m = moment(job.scheduleTime).utc().format('YYYY-MM-DDTHH:MM');
      isNew = false;
      jobParamenter.jobName = job.jobName;
      jobParamenter.jobScheduleTime = m;
      jobParamenter.cronExpression = job.cronEx;
    }

    this.dialog.open(CreateJobModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { jobParamenter, isNew }
    }).afterClosed().subscribe((data) => {
      if (!data) {
        return;
      }
      Log.debug('data', data);
      this.getJobs();
    });
  }

  getJobs(){
    this.restService.getJobs().subscribe(result => {
      Log.debug('getJobs', result);
      this.jobs = result.data;
    });
  }

}



@Component({
  selector: 'app-create-job-modal-content',
  templateUrl: './create-job-modal.component.html',
  styleUrls: ['./admin-schedule.page.scss']
})
export class CreateJobModalContent implements OnInit {
  jobParamenter: JobParamenterModel;
  isNew: boolean;
  cronNames: string[] = [];

  constructor(public activeModal: MatDialogRef<CreateJobModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { jobParamenter: JobParamenterModel; isNew: boolean },
              private restService: RestService,
              public appService: AppService) {
                this.jobParamenter = data?.jobParamenter;
                this.isNew = data?.isNew;
                console.log('CreateJobModalContent')
              }

              
  ngOnInit(): void {
    console.log('jobParamenter', this.jobParamenter);
    this.getCronNames();
  }

  handlerResponse(result:any){
    if(result.statusCode == 200){
      this.appService.showSuccessToast("Acción realizada correctamente");
      this.activeModal.close({refresh:true});
    }else{
      this.appService.showDangerToast(result.statusCode);
    }
  }     
 
  cancel() {
      this.activeModal.close();
  }

  confirm() {
    console.log('managerJob', this.jobParamenter);

    if(this.isNew){
      this.postManagerJob(this.jobParamenter);
    }else{
      this.putManagerJob(this.jobParamenter);
    }
    
  }
  
  postManagerJob(jobParamenter:JobParamenterModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.createJob(jobParamenter).subscribe(result => {
      console.log('createJob', result);
      this.handlerResponse(result);
    });
  }

  putManagerJob(jobParamenter:JobParamenterModel){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.updateJob(jobParamenter).subscribe(result => {
      console.log('putManagerJob', result);
      this.handlerResponse(result);
    });
  }

  deleteManagerJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.deleteJob(this.jobParamenter).subscribe(result => {
      console.log('deleteJob', result);
      this.handlerResponse(result);
    });

  }

  unscheduleJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.unscheduleJob(this.jobParamenter).subscribe(result => {
      console.log('unscheduleJob', result);
      this.handlerResponse(result);
    });

  }

  pauseJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.pauseJob(this.jobParamenter).subscribe(result => {
      console.log('pauseJob', result);
      this.handlerResponse(result);
    });
    
  }

  resumeJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.resumeJob(this.jobParamenter).subscribe(result => {
      console.log('resumeJob', result);
      this.handlerResponse(result);
    });

  }

  checkJobNameJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.checkJobNameJob(this.jobParamenter).subscribe(result => {
      console.log('checkJobNameJob', result);
      this.handlerResponse(result);
    });
   
  }

  isJobRunningJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.isJobRunningJob(this.jobParamenter).subscribe(result => {
      console.log('isJobRunningJob', result);
      this.handlerResponse(result);
    });

  }

  jobStateJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.jobStateJob(this.jobParamenter).subscribe(result => {
      console.log('jobStateJob', result);
      this.handlerResponse(result);
    });
   
  }


  stopJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }

    this.restService.stopJob(this.jobParamenter).subscribe(result => {
      console.log('stopJob', result);
      this.handlerResponse(result);
    });
   
  }

  startJob(){
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
   
    this.restService.startJob(this.jobParamenter).subscribe(result => {
      console.log('startJob', result);
      this.handlerResponse(result);
    });
    
  }


  getCronNames(){
    this.restService.getCronNames().subscribe(result => {
      console.log('getNameCron', result);
      this.cronNames = result;
    });
  }


}
